import React from 'react';
import topIntern from '../images/TopInternFix.svg';

function Fix(){
    return(
        <div className='fixStart'>
            <ul>
                <img src={topIntern} alt="" />
                <li>How it works</li>
                <li>Sample sessions</li>
                <li>Certificates</li>
                <li>Program guide</li>
                <li>Pricing</li>
                <li>Testimonails</li>
                <li>Our team</li>
                <li>FAQs</li>
            </ul>
        </div>
    )
};

export default Fix;